import { useEffect } from "react";
import { EMPTY_MESSAGES, EMPTY_MESSAGE_IMAGES, FONTS } from "../../constants";
import Dataset from "../../MachineLearning/Dataset";
import { PCAEncoder } from "../../MachineLearning/PCAReduction";
import { stateType, stateTypeF } from "../../state";

import { useStyles } from "../DataIngestion/DataIngestion";
// import { GroupStats } from "./GroupStatsBox";
import { EmptyMessage } from "../Common/EmptyMessage";
import { SentimentBox } from "./SentimentBox";
import { DropDown } from "./DropDown";
import { TopSentChart } from "./TopSentChart";
import { CloudBox } from "./CloudBox";
import { notifyPageView } from "../../analytics/useAnalyticsEventTracker";
import { setMetaTags } from "../../helpers/pageMeta";

export function SentimentAnalysis({ state }: stateType) {
	let classes = useStyles();
	useEffect(() => {
		setMetaTags();
		window.scrollTo(0, 0);
		notifyPageView("Sentiment Analysis Page", window.location.pathname);
	}, []);

	if (state.saveState.dataset.visualizationData === undefined) {
		return (
			<EmptyMessage
				image={EMPTY_MESSAGE_IMAGES.pleaseTrain}
				message1={EMPTY_MESSAGES.noText1}
				message2={EMPTY_MESSAGES.noText2}
				button={false}
			></EmptyMessage>
		);
	}

	return (
		<div className={classes.root}>
			<div className={classes.grid}>
				<div className={classes.title}>Natural Language Processing</div>
				<div
					style={{
						display: "flex",
						marginTop: "40px",
						marginBottom: "-40px",
						marginRight: "5px",
						zIndex: 1000,
					}}
				>
					<div
						style={{
							fontSize: "18px",
							fontFamily: FONTS,
							color: "rgba(0,0,0,0.8)",
						}}
					>
						Column:{" "}
					</div>
					<DropDown state={state}></DropDown>
				</div>
			</div>
			<div className={classes.grid}>
				<div className={classes.subTitle}>
					Analyze the sentiment (positivity/negativity) of your text
					content here.
				</div>
			</div>
			<div className={classes.divider2}></div>
			<div className={classes.grid}>
				<SentimentBox state={state}></SentimentBox>
			</div>
			<div className={classes.divider2}></div>
			<div className={classes.grid}>
				<TopSentChart state={state}></TopSentChart>
			</div>
			<div className={classes.divider2}></div>
			<div className={classes.grid}>
				<div className={classes.title}>
					Positive and Negative Topics
				</div>
			</div>
			<div className={classes.grid}>
				<CloudBox state={state} isPos={true}></CloudBox>
			</div>
			<div className={classes.divider2}></div>
			<div className={classes.grid}>
				<CloudBox state={state} isPos={false}></CloudBox>
			</div>
		</div>
	);
}
